import React, { useEffect, useRef, useState } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import PhotoThumbSign from "../components/PhotoThumbSign";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { useSelector } from "react-redux";
import ApiLoader from "../components/ApiLoader";
import CameraPopup from "../components/CameraPopup";
import SignaturePopup from "../components/SignaturePopup";
import fingerPrintServices from "../services/fingerPrintService";
import FingerprintScannerLoader from "../components/FingerprintScannerLoader";
import dummyFingerprint from "../assets/images/dummyFingerPrint.jpg";
import dummyPhoto from "../assets/images/dummyPhoto.png";
import dummySignature from "../assets/images/dummySignature.png";
import { useDispatch } from "react-redux";
import {
  setThumbFingerprintImage,
  setThumbFingerprintData,
  removeImage,
  removeSignature,
  removeThumbFingerprintData,
  removeThumbFingerprintImage,
  clearAllData,
  setSignature,
} from "../redux-store/slices/usersData";
import { addUser, clearUsers } from "../redux-store/slices/partyDetailsSlice";
import validatePhotoThumbAndSignData from "../utilities/validatePhotoThumbAndSignData";
import { toast } from "react-toastify";
import { setImage } from "../redux-store/slices/usersData";
import { updateUser } from "../redux-store/slices/partyDetailsSlice";
import { TurnLeft } from "@mui/icons-material";
import REPORT_BASE_URL from "../utilities/ReportConfig";
import CommissionDetailsModal from "../Modal/CommissionDetailsModal";

const PhotoThumbSignForm = () => {
  const [loadingPage, setLoadingPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [registeredPartyList, setRegisteredPartyList] = useState([]);
  const [deedData, setDeedData] = useState([]);
  const [fingerprintScannerLoading, setFingerprintScannerLoading] =
    useState(false);

  const [fingerprintData, setFingerprintData] = useState("");
  const [fingerprintImage, setFingerprintImage] = useState("");
  const [hasDispatched, setHasDispatched] = useState(false);

  const [partyName, setPartyName] = useState("");
  const [partyPcode, setPartyPcode] = useState("");
  const [openMessagePopup, setOpenMessagePopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [photo, setPhoto] = useState(dummyPhoto);
  const [signature, setSignatureImage] = useState(dummySignature);
  const [fingerpirnt, setFingerpintImage] = useState(dummyFingerprint);
  const [partyDetailsListFound, setPartyDetailsListFound] = useState(false);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  const selectedTokenDetails = location?.state?.selectedTokenDetails;
  const partyDetailsModeFromRegistrationTokenList = location?.state?.mode;
  const partyDetailsSourceFromRegistrationTokenList = location?.state?.source;
  debugger;
  const postponedPartyDetails = location?.state?.partyListData;

  const { dcode, srocode } = useSelector((state) => state?.auth?.userDetails);
  const usersData = useSelector((state) => state?.data);
  const partyDetailsReduxData = useSelector((state) => state?.partyDetails);

  console.log("user redux data", usersData);
  console.log(
    "registered party mode",
    partyDetailsModeFromRegistrationTokenList
  );
  console.log(
    "registered party source",
    partyDetailsSourceFromRegistrationTokenList
  );
  console.log("party details redux data", partyDetailsReduxData);
  console.log("selected token details", selectedTokenDetails);
  console.log("selected party details", postponedPartyDetails);
  // const { deed, subDeed, regYear, tokenDate, tokenNo } =
  //   selectedTokenDetails[0];
  // const bookNo = registeredPartyList[0]?.bookNo;
  debugger;
  const [isPostponedDocument, setIsPostponedDocument] = useState(false);
  const [isImpoundDocument, setIsImpoundDocument] = useState(false);
  const [isCommissionDocument, setIsCommissionDocument] = useState(false);
  const [showCommissionModal, setShowCommissionModal] = useState(false);
  const [commissionData, setCommissionData] = useState(null);

  const [showCameraModalPopup, setShowCameraModalPopup] = useState(false);
  const handleCameraModalPopupClose = () => setShowCameraModalPopup(false);
  const handleCameraModalPopupShow = () => setShowCameraModalPopup(true);

  const [showSignatureModalPopup, setShowSignatureModalPopup] = useState(false);
  const handleSignatureModalPopupClose = () =>
    setShowSignatureModalPopup(false);
  const handleSignatureModalPopupShow = () => setShowSignatureModalPopup(true);

  const partyIndividualBasicDetails = {
    pCode: "",
    image: "",
    thumb: "",
    sign: "",
    name: "",
    thumbimg: "",
  };

  const registrationCombinedData = {
    dCode: dcode,
    sroCode: srocode,
    tokenNo: selectedTokenDetails[0]?.tokenNo,
    tokenDate: selectedTokenDetails[0]?.tokenDate,
    mode:
      partyDetailsModeFromRegistrationTokenList === "POSTPONED"
        ? "Postpone"
        : "Registration",
    // source: "New",
    source:
      partyDetailsSourceFromRegistrationTokenList === "Postpone"
        ? "Postpone"
        : "New",
    refNo: 0,
    comAppName: "",
    comPCode: "",
    comAdd: "",
    commVol: "",
    commSr: "",
    commApplDate: "",
    photoImages: partyDetailsReduxData,
  };

  console.log("party combined data to send", registrationCombinedData);

  const [selectedPartyData, setSelectedPartyData] = useState(
    partyIndividualBasicDetails
  );

  const [partyDataList, setPartyDataList] = useState([]);

  const {
    callSGIFPGetData,
    successFunc1,
    errorFunc,
    matchFingerPrint,
    succMatch,
    failureFunc,
  } = fingerPrintServices();

  const handleGetPartyDetailsUsingParameters = async (tokenDetails) => {
    try {
      setLoadingPage(true);
      const response = await axios.get(
        `${API_BASE_URL}/Registration/get_party_details_modewise_using_dcode_srocode_token_date_token_no/${dcode}/${srocode}/${tokenDetails.tokenDate}/${tokenDetails.tokenNo}/${partyDetailsModeFromRegistrationTokenList}`
      );
      console.log("Registered party list details", response.data);
      if (response.data?.statusCode === 200) {
        setRegisteredPartyList(response.data?.registeredPartyDetailsList);
        console.log(
          "registeredPartyList:",
          response.data?.registeredPartyDetailsList
        );

        debugger;
        setPartyDetailsListFound(true);
      } else {
        toast.error(response.data?.status);
      }
    } catch (error) {
      console.log("handle party details error", error);
    } finally {
      setLoadingPage(false);
    }
  };
  const handleGetDeedData = async (tokenDetails) => {
    try {
      setLoadingPage(true);
      const response = await axios.get(
        `${API_BASE_URL}/Registration/get_deed_data/${dcode}/${srocode}/${tokenDetails.tokenDate}/${tokenDetails.tokenNo}`
      );
      console.log("Deed details", response.data);
      if (response.data?.statusCode === 200) {
        setDeedData(response.data?.deedData);
        debugger;
      } else {
        toast.error(response.data?.status);
      }
    } catch (error) {
      console.log("handle deed data details error", error);
    } finally {
      setLoadingPage(false);
    }
  };

  const captureFingerprint = () => {
    setFingerprintScannerLoading(true);
    callSGIFPGetData((result) => {
      successFunc1(result);
      setFingerprintData(result.ISOTemplateBase64);
      setFingerprintImage("data:image/bmp;base64," + result.BMPBase64);
      dispatch(
        setThumbFingerprintImage("data:image/bmp;base64," + result.BMPBase64)
      );
      dispatch(setThumbFingerprintData(result.ISOTemplateBase64));
      setFingerprintScannerLoading(false);
    }, errorFunc);
  };

  // const handleAddDataToSelectedPartyList = (e) => {
  //   e.preventDefault();
  //   debugger;
  //   const errors = validatePhotoThumbAndSignData(selectedPartyData);

  //   if (errors.length > 0) {
  //     debugger;
  //     errors.forEach((error) => {
  //       toast.error(error);
  //     });
  //   } else {
  //     console.log("dispatching data into redux", selectedPartyData);
  //     if (
  //       partyDetailsReduxData.some(
  //         (item) => item.pCode === selectedPartyData.pCode
  //       )
  //     ) {
  //       debugger;
  //       dispatch(updateUser(selectedPartyData));
  //       toast.success("selected party data updated");
  //     } else {
  //       setPartyDataList({ ...partyDataList, selectedPartyData });

  //       dispatch(addUser(selectedPartyData));
  //       dispatch(clearAllData());
  //       setSelectedPartyData(partyIndividualBasicDetails);
  //       toast.success("selected party data saved");
  //     }
  //   }
  // };

  const handleAddDataToSelectedPartyList = (e) => {
    e.preventDefault();
    const errors = validatePhotoThumbAndSignData(selectedPartyData);

    if (errors.length > 0) {
      errors.forEach((error) => toast.error(error));
      return;
    }

    // 1. compute once whether we’re updating or adding
    const exists = partyDetailsReduxData.some(
      (item) => item.pCode === selectedPartyData.pCode
    );

    // 2. dispatch the right action
    if (exists) {
      dispatch(updateUser(selectedPartyData));
    } else {
      // if you’re still maintaining a local list state:
      setPartyDataList({
        ...partyDataList,
        [selectedPartyData.pCode]: selectedPartyData,
      });
      dispatch(addUser(selectedPartyData));
    }

    // 3. reset the *form* (not the entire slice) after either case
    dispatch(clearAllData());
    setSelectedPartyData(partyIndividualBasicDetails);

    // 4. single toast for both add & update
    toast.success(
      exists
        ? `${selectedPartyData.name}'s data updated`
        : `${selectedPartyData.name}'s data saved`
    );
  };

  const handlePartySelect = (e) => {
    dispatch(clearAllData());
    const { name, value } = e.target;
    console.log(e.target);
    if (name === "pcode") {
      setPartyPcode(value);
      setPartyName(value);

      const filteredParty = registeredPartyList.find(
        (party) => party.pcode === value
      );

      const slelectedPartyName = filteredParty ? filteredParty.nameEng : null;

      console.log(slelectedPartyName);

      setSelectedPartyData({
        ...selectedPartyData,
        name: slelectedPartyName,
        pCode: value,
      });
    }
    if (partyDetailsReduxData.some((item) => item.pCode === value)) {
      console.log(
        "selected from redux",
        partyDetailsReduxData.find((item) => item.pCode === value)
      );

      setSelectedPartyData(
        partyDetailsReduxData.find((item) => item.pCode === value)
      );

      setFingerpintImage(
        partyDetailsReduxData.find((item) => item.pCode === value)?.thumbimg
      );
      setPhoto(
        partyDetailsReduxData.find((item) => item.pCode === value)?.image
      );
      setSignatureImage(
        partyDetailsReduxData.find((item) => item.pCode === value)?.sign
      );

      dispatch(
        setImage(
          partyDetailsReduxData.find((item) => item.pCode === value)?.image
        )
      );
      dispatch(
        setSignature(
          partyDetailsReduxData.find((item) => item.pCode === value)?.sign
        )
      );
      dispatch(
        setThumbFingerprintImage(
          partyDetailsReduxData.find((item) => item.pCode === value)?.thumbimg
        )
      );
      dispatch(
        setThumbFingerprintData(
          partyDetailsReduxData.find((item) => item.pCode === value)?.thumb
        )
      );
    }
  };

  const handleGetRegYearAndRegNoWithOtherDetails = async (tokenNo) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/Registration/get_details_from_cashreceipt_using_token_no/${tokenNo}`
      );
      console.log(response.data);
      if (response.data?.statusResponse?.statusCode === 200) {
        setSuccessMessage(response.data?.cashReceiptDetails);
        setOpenMessagePopup(true);
      } else {
        toast.error(response.data?.statusResponse?.status);
      }
    } catch (error) {
      console.log(
        "handle get reg year and reg no with other details error ",
        error
      );
      toast.error(
        "An Error Occured while fetching the details pleae try again"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFinalApiSend = async (e) => {
    e.preventDefault();
    debugger;
    if (registeredPartyList.length === partyDetailsReduxData.length) {
      try {
        setLoading(true);
        const response = await axios.post(
          `${API_BASE_URL}/Registration/post_partydetails`,
          registrationCombinedData,
          {
            headers: {
              Accept: "*/*",
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response.data);
        if (response.data?.statusCode === 200) {
          // toast.success(response.data?.status);
          // handleGetRegYearAndRegNoWithOtherDetails(selectedTokenDetails[0]?.tokenNo)
          setSuccessMessage(response.data?.data);
          setOpenMessagePopup(true);
        }
        if (response.data?.statusCode === 400) {
          toast.error(response.data?.data?.errorMessage);
        }
      } catch (error) {
        console.log("Error in Final Api Submit", error);
        toast.error("Failed to Submit data due to unexpected reasons");
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please take the Details of all party members");
    }
  };

  const handleCommissionProceed = async (data) => {
    console.log("Received Commission Data:", data);
    setCommissionData(data);
    const commData = {
      dCode: dcode,
      sroCode: srocode,
      tokenNo: selectedTokenDetails[0]?.tokenNo,
      tokenDate: selectedTokenDetails[0]?.tokenDate,
      mode:
        partyDetailsModeFromRegistrationTokenList === "POSTPONED"
          ? "Postpone"
          : "Registration",
      source: "New",
      refNo: 0,
      comAppName: data.appName,
      comPCode: data.selectedOption,
      comAdd: data.commissionAddress,
      commVol: data.volume,
      commSr: data.srNo,
      commApplDate: data.applicationDate,
      photoImages: [],
    };
    debugger;

    try {
      setLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/Registration/post_partydetails`,
        commData,
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Commission API Response:", response.data);

      if (response.data?.statusCode === 200) {
        setSuccessMessage(response.data?.data);
        setOpenMessagePopup(true);
      } else if (response.data?.statusCode === 400) {
        toast.error(response.data?.data?.errorMessage);
      }
    } catch (error) {
      console.error("Error in Commission API Submit", error);
      toast.error(
        "Failed to submit commission details due to unexpected reasons"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleMessagePopupWithPDF = () => {
    const url = `${REPORT_BASE_URL}/Report/RegistrationDocument.aspx?pi_docode=${dcode}&pi_srocode=${srocode}&pi_vol=${successMessage?.vol}&pi_sr=${successMessage?.sr}&pi_year=${successMessage?.regYear}`;
    window.open(url, "_blank");
    setOpenMessagePopup(false);
    navigate("/RegistrationTokenList");
    dispatch(clearUsers());
  };

  const handleClearAllData = (e) => {
    e.preventDefault();
    dispatch(clearUsers());
  };
  useEffect(() => {
    debugger;
    // Automatically set Impound and Commission based on deedData
    setIsCommissionDocument(deedData?.commission === "Y");
    // setIsImpoundDocument(deedData?.deedCode === "02"); // Modify logic if needed
    if (partyDetailsModeFromRegistrationTokenList === "POSTPONED") {
      setIsPostponedDocument(true);
    }
  }, [deedData, partyDetailsModeFromRegistrationTokenList]);

  const handleModeChange = () => {
    debugger;
    setIsPostponedDocument((prev) => !prev); // Toggle Postponed Document manually
  };

  useEffect(() => {
    console.log(selectedTokenDetails);
    const { deed, subDeed, regYear, tokenDate, tokenNo } =
      selectedTokenDetails[0];

    console.log(
      "Selected token details:",
      deed,
      subDeed,
      regYear,
      tokenDate,
      tokenNo
    );
    debugger;
    if (partyDetailsModeFromRegistrationTokenList !== "POSTPONED") {
      handleGetPartyDetailsUsingParameters(selectedTokenDetails[0]);
      handleGetDeedData(selectedTokenDetails[0]);
    } else {
      setRegisteredPartyList(postponedPartyDetails);
    }
  }, [selectedTokenDetails]);

  useEffect(() => {
    const updatedPhoto = usersData?.image || dummyPhoto;
    const updatedSignature = usersData?.signature || dummySignature;
    const updatedFingerprint =
      usersData?.thumbFingerprint?.image || dummyFingerprint;
    const updatedFingerprintData = usersData?.thumbFingerprint?.data;

    setPhoto(updatedPhoto);
    setSignatureImage(updatedSignature);
    setFingerpintImage(updatedFingerprint);

    setSelectedPartyData((prevState) => ({
      ...prevState,
      image: updatedPhoto,
      sign: updatedSignature,
      thumb: updatedFingerprintData,
      thumbimg: updatedFingerprint,
    }));

    console.log("selected user photo thumb sign", selectedPartyData);
  }, [usersData, partyName, registeredPartyList]);

  // useEffect(() => {
  //     dispatch(clearUsers());
  //     dispatch(clearAllData());
  // }, []);

  useEffect(() => {
    dispatch(clearAllData());
  }, []);

  return (
    <>
      {loading && <ApiLoader />}
      {fingerprintScannerLoading && <FingerprintScannerLoader />}

      <CameraPopup
        show={showCameraModalPopup}
        handleClose={handleCameraModalPopupClose}
      />
      <SignaturePopup
        show={showSignatureModalPopup}
        handleClose={handleSignatureModalPopupClose}
      />

      <div className="flex h-screen overflow-hidden">
        <SideMenu />
        <div className="flex-1 flex flex-col">
          <Header />
          <div className="flex flex-1">
            {registeredPartyList.length > 0 ? (
              <div className="flex-1 mx-2">
                <h1 className="font-semibold mt-3">
                  Photo, Thumb and Signature Capturing Form
                </h1>
                <div className="p-2 bg-[#F4F4F4] min-h-screen">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex space-x-4">
                      <div>
                        Book No :{" "}
                        <span className="font-semibold">
                          {registeredPartyList[0]?.bookNo}
                        </span>
                      </div>
                      <div>
                        Token No :{" "}
                        <span className="font-semibold">
                          {registeredPartyList[0]?.tokenNo}
                        </span>
                      </div>
                      <div>
                        Token Year :{" "}
                        <span className="font-semibold">
                          {registeredPartyList[0]?.regYear}
                        </span>
                      </div>
                    </div>
                    <div className="space-x-2">
                      <input
                        type="text"
                        placeholder="Device Name"
                        className="border rounded-md p-1"
                      />
                      <button className="bg-blue-500 text-white px-4 py-1 rounded-md">
                        Int
                      </button>
                      <button className="bg-blue-500 text-white px-4 py-1 rounded-md">
                        Enumerate
                      </button>
                      <button
                        onClick={(e) => {
                          handleClearAllData(e);
                        }}
                        className="bg-red-500 text-white px-4 py-1 rounded-md"
                      >
                        ClearAllData
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 gap-2 mb-4">
                    <TextField
                      label="Deed"
                      variant="outlined"
                      fullWidth
                      value={selectedTokenDetails[0].deed}
                      sx={{
                        height: "56px",
                        zIndex: 0,
                        "& .MuiInputBase-input": {
                          height: "100%",
                        },
                        "& .MuiInputLabel-root": {
                          transform: selectedTokenDetails[0].deed
                            ? "translate(14px, -6px) scale(0.75)"
                            : "translate(14px, 18px) scale(1)",
                          transition: "transform 0.2s ease-in-out",
                        },
                      }}
                      InputLabelProps={{
                        shrink: !!selectedTokenDetails[0].deed,
                      }}
                    />

                    <TextField
                      label="Sub-Deed"
                      fullWidth
                      value={selectedTokenDetails[0].subDeed}
                      sx={{
                        height: "48px",
                        "& .MuiInputBase-input": {
                          height: "100%",
                        },
                        "& .MuiInputLabel-root": {
                          transform: selectedTokenDetails[0].subDeed
                            ? "translate(14px, -6px) scale(0.75)"
                            : "translate(14px, 20px) scale(1)",
                          transition: "transform 0.2s ease-in-out",
                        },
                      }}
                      InputLabelProps={{
                        shrink: !!selectedTokenDetails[0].subDeed,
                      }}
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <div className="mb-4">
                        {/* <label className="inline-flex items-center mr-4">
                          <input
                            type="checkbox"
                            checked={
                              partyDetailsModeFromRegistrationTokenList ===
                              "POSTPONED"
                            }
                            onChange={handleModeChange}
                            className="form-checkbox"
                          />
                          <span className="ml-2">Postponed Document</span>
                        </label>
                        <label className="inline-flex items-center mr-4">
                          <input
                            type="checkbox"
                            disabled
                            className="form-checkbox"
                          />
                          <span className="ml-2">Impound Document</span>
                        </label>
                        <label className="inline-flex items-center">
                          <input
                            type="checkbox"
                            disabled
                            className="form-checkbox"
                          />
                          <span className="ml-2">Commission Document</span>
                        </label> */}
                        <label className="inline-flex items-center mr-4">
                          <input
                            type="checkbox"
                            className="form-checkbox"
                            checked={isPostponedDocument}
                            readOnly
                            // onChange={handleModeChange} // Allow manual toggle
                          />
                          <span className="ml-2">Postponed Document</span>
                        </label>

                        <label className="inline-flex items-center mr-4">
                          <input
                            type="checkbox"
                            className="form-checkbox"
                            checked={isImpoundDocument}
                            readOnly // Auto-controlled
                          />
                          <span className="ml-2">Impound Document</span>
                        </label>

                        <label className="inline-flex items-center">
                          <input
                            type="checkbox"
                            className="form-checkbox"
                            checked={isCommissionDocument}
                            readOnly // Auto-controlled
                          />
                          <span className="ml-2">Commission Document</span>
                        </label>
                      </div>

                      <div className="mb-4">
                        <h3 className="font-semibold">
                          Party Whose Photo, Thumb and Signature are Taken
                        </h3>
                        <div className="font-semibold text-gray-500">
                          {registeredPartyList.filter(
                            (partyDetails) => partyDetails.pcode === partyPcode
                          )[0]?.nameHin || ""}
                        </div>
                      </div>

                      <div className="mb-4">
                        <table className="w-full border-collapse">
                          <thead>
                            <tr className="bg-gray-200">
                              <th className="border px-4 text-sm py-2">Name</th>
                              <th className="border px-4 text-sm py-2">
                                Photo
                              </th>
                              <th className="border px-4 text-sm py-2">
                                Thumb
                              </th>
                              <th className="border px-4 text-sm py-2">Sign</th>
                              {/* <th className="border px-4 text-sm py-2">Photodate</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {registeredPartyList.map((party, index) => (
                              <tr key={index} className="bg-white">
                                <td
                                  className={`border px-4 py-2 ${
                                    partyPcode === party.pcode
                                      ? "bg-green-500 text-white"
                                      : "bg-gray-200 text-black"
                                  }`}
                                >
                                  {party.nameEng}
                                </td>
                                <td className="border px-4 py-2">
                                  <input
                                    type="checkbox"
                                    checked={
                                      (usersData?.image &&
                                        partyPcode === party.pcode) ||
                                      partyDetailsReduxData.some(
                                        (item) => item.pCode === party.pcode
                                      )
                                    }
                                    readOnly
                                  />
                                </td>
                                <td className="border px-4 py-2">
                                  <input
                                    type="checkbox"
                                    checked={
                                      (usersData?.thumbFingerprint?.data &&
                                        partyPcode === party.pcode) ||
                                      partyDetailsReduxData.some(
                                        (item) => item.pCode === party.pcode
                                      )
                                    }
                                    readOnly
                                  />
                                </td>
                                <td className="border px-4 py-2">
                                  <input
                                    type="checkbox"
                                    checked={
                                      (usersData?.signature &&
                                        partyPcode === party.pcode) ||
                                      partyDetailsReduxData.some(
                                        (item) => item.pCode === party.pcode
                                      )
                                    }
                                    readOnly
                                  />
                                </td>
                                {/* <td className="border px-4 py-2"></td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div>
                      {/* Selection Section */}
                      <div className="flex flex-col space-y-4 mb-4">
                        <select
                          name="pcode"
                          value={partyPcode}
                          onChange={handlePartySelect}
                          className="border rounded-md p-2 w-full"
                          disabled={isCommissionDocument}
                        >
                          <option disabled value="">
                            select
                          </option>
                          {registeredPartyList.map((party, index) => (
                            <option key={index} value={party.pcode}>
                              {party.nameEng}
                            </option>
                          ))}
                        </select>

                        <div className="flex flex-col space-y-4 mb-4 mt-3">
                          <div className="flex space-x-4 mt-4">
                            <button
                              onClick={handleCameraModalPopupShow}
                              className="w-32 h-10 bg-blue-500 text-white text-sm px-4 py-2 rounded-md"
                              disabled={isCommissionDocument}
                            >
                              + PHOTO
                            </button>
                            <button
                              onClick={captureFingerprint}
                              className="w-32 h-10 bg-blue-500 text-white text-sm px-4 py-2 rounded-md"
                              disabled={isCommissionDocument}
                            >
                              + THUMB
                            </button>
                            <button
                              onClick={handleSignatureModalPopupShow}
                              className="w-32 h-10 bg-blue-500 text-white text-sm px-4 py-2 rounded-md"
                              disabled={isCommissionDocument}
                            >
                              + SIGNATURE
                            </button>
                          </div>

                          <div className="flex space-x-4 mt-4">
                            <div className="w-32 h-44 border rounded-md bg-gray-100 overflow-hidden flex items-center justify-center">
                              {/* <span
                                                            className="block bg-cover bg-center max-h-full"
                                                            style={{
                                                                backgroundImage: "url('path/to/dummy-photo.jpg')",
                                                                height: '150px',
                                                                width: '100px', // Adjust the width for the photo
                                                            }}
                                                        /> */}
                              <img
                                src={photo}
                                alt="user image"
                                height={150}
                                width={150}
                              />
                            </div>
                            <div className="w-32 h-44 border rounded-md bg-gray-100 overflow-hidden flex items-center justify-center">
                              {/* <span
                                                            className="block bg-cover bg-center max-h-full"
                                                            style={{
                                                                backgroundImage: "url('path/to/dummy-thumb.jpg')",
                                                                height: '150px',
                                                                width: '50px', // Adjust the width for the thumb
                                                            }}
                                                        /> */}
                              <img
                                src={fingerpirnt}
                                alt="fingerprint image"
                                height={150}
                                width={150}
                              />
                            </div>
                            <div className="w-32 h-44 border rounded-md bg-gray-100 overflow-hidden flex items-center justify-center">
                              {/* <span
                                                            className="block bg-cover bg-center max-h-full"
                                                            style={{
                                                                backgroundImage: "url('path/to/dummy-signature.jpg')",
                                                                height: '150px',
                                                                width: '150px', // Adjust the width for the signature
                                                            }}
                                                        /> */}
                              <img
                                src={signature}
                                alt="signature image"
                                height={150}
                                width={150}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Save Button */}
                      {/* <div className="flex justify-center align-middle flex-col-1 space-y-4 mb-4">
                        
                        <button
                          onClick={(e) => {
                            handleAddDataToSelectedPartyList(e);
                          }}
                          className="bg-blue-500 text-white px-6 py-2 rounded-md w-full"
                        >
                          SAVE PHOTO, THUMB AND SIGNATURE
                        </button>
                      </div> */}

                      {/* <div className="flex justify-center align-middle flex-col-1 space-y-4 mb-4">
                        <button
                          onClick={(e) => {
                            if (isCommissionDocument) {
                              setShowCommissionModal(true); // Open modal if it's a commission document
                            } else {
                              handleAddDataToSelectedPartyList(e);
                            }
                          }}
                          className="bg-blue-500 text-white px-6 py-2 rounded-md w-full"
                        >
                          {isCommissionDocument
                            ? "ADD COMMISSION DOCUMENT"
                            : "SAVE PHOTO, THUMB AND SIGNATURE"}
                        </button>
                      </div> */}

                      <div className="flex justify-center align-middle flex-col-1 space-y-4 mb-4">
                        <button
                          onClick={(e) => {
                            if (isCommissionDocument) {
                              setShowCommissionModal(true); // Open modal if it's a commission document
                            } else {
                              handleAddDataToSelectedPartyList(e);
                            }
                          }}
                          className="bg-blue-500 text-white px-6 py-2 rounded-md w-full"
                        >
                          {isCommissionDocument
                            ? "ADD COMMISSION DOCUMENT"
                            : isPostponedDocument
                            ? "ADD POSTPONED DOCUMENT"
                            : "SAVE PHOTO, THUMB AND SIGNATURE"}
                        </button>
                      </div>

                      {/* Show the Submit button below the div only when all parties have provided their details */}
                      {registeredPartyList.length > 0 &&
                        registeredPartyList.every((party) =>
                          partyDetailsReduxData.some(
                            (item) =>
                              item.pCode === party.pcode &&
                              item.image &&
                              item.thumb &&
                              item.sign
                          )
                        ) && (
                          <div className="flex justify-center align-middle flex-col-1 space-y-4 mb-4">
                            <button
                              onClick={(e) => {
                                handleFinalApiSend(e);
                              }}
                              type="button"
                              class="text-primary-50 bg-success-500 hover:bg-success-800 focus:outline-none focus:ring-4 focus:ring-success-300 font-medium rounded-md text-sm px-5 py-2.5 text-center me-2 mb-2 dark:bg-success-600 dark:hover:bg-success-700 dark:focus:ring-success-800"
                            >
                              Submit Details
                            </button>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                {showCommissionModal && (
                  <CommissionDetailsModal
                    onClose={() => setShowCommissionModal(false)}
                    // deed={selectedTokenDetails[0]?.deed}
                    // subDeed={selectedTokenDetails[0]?.subDeed}
                    // regYear={selectedTokenDetails[0]?.regYear}
                    onProceed={handleCommissionProceed}
                    tokenDate={selectedTokenDetails[0]?.tokenDate}
                    tokenNo={selectedTokenDetails[0]?.tokenNo}
                    bookNo={registeredPartyList[0]?.bookNo}
                  />
                )}
              </div>
            ) : (
              <ApiLoader />
            )}

            {/* Right Side */}
            <div className="w-64 h-full">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>

      <Dialog open={openMessagePopup} onClose={handleMessagePopupWithPDF}>
        <DialogTitle className="bg-gray-800 text-white">
          Popup Title
        </DialogTitle>
        <DialogContent className="bg-white p-4 px-10">
          <p className="text-gray-700 text-bold">{`Your Details for Mode : ${successMessage?.mode}, Registration No : ${successMessage?.regno} and Registration Year : ${successMessage?.regYear} , Dcode : ${dcode}, SroCode :  ${srocode} saved successfully`}</p>
          {/* <p className="text-gray-700 text-bold">{`Your Details for Mode : ${successMessage?.mode}, Registration No : ${successMessage?.regno}, Dcode : ${dcode}, SroCode :  ${srocode} saved successfully`}</p> */}
        </DialogContent>
        <DialogActions className="bg-gray-100">
          <Button
            onClick={handleMessagePopupWithPDF}
            className="bg-green-500 hover:bg-green-700 text-white py-1 px-3 rounded"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PhotoThumbSignForm;
